import { schema } from 'normalizr'

const callLog = new schema.Entity('callLogs')

export default callLog
